import { CommonDT, DateFilter, PageParams, ResultType, Sorter } from '../../CommonDT';
import { _delete, _get, _post, _put, _req } from '../../request';

export type AnnoDataType = CommonDT & {
  annoName: string;
  annoContent: string;
};

export type AnnoBatchDataType = {
  annos: AnnoDataType[];
};

export type AnnoPageDataType = {
  pageParams: PageParams;
  filter?: AnnoDataType;
  dateFilter?: DateFilter;
  sorter?: Sorter;
};

const get = async (id: string): Promise<ResultType> => {
  return await _get('/ope/anno/', id);
};

const list = async (data?: AnnoDataType): Promise<ResultType> => {
  return await _post('/ope/anno/list', data);
};

const page = async (data?: AnnoPageDataType): Promise<ResultType> => {
  return await _post('/ope/anno/page', data);
};

const batchSave = async (data: AnnoBatchDataType): Promise<ResultType> => {
  return await _post('/ope/anno/batchSave', data);
};

const batchUpdate = async (data: AnnoBatchDataType): Promise<ResultType> => {
  return await _put('/ope/anno/batchUpdate', data);
};

const alterStatus = async (annoId: string, status: number): Promise<ResultType> => {
  return await _req('/ope/anno/alterStatus', 'PUT', { annoId, status });
};

const batchRemove = async (ids: string[]): Promise<ResultType> => {
  return await _delete('/ope/anno/batchRemove', ids);
};

const AnnoApi = {
  get,
  list,
  page,
  batchSave,
  batchUpdate,
  alterStatus,
  batchRemove,
};

export default AnnoApi;
